import _ from 'lodash';
import { IValidatorFactoryService } from './validator-factory.service';
import { IIntegerMetadata } from 'app/extensibility/metadatas/validator/integer-metadata';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';

/**
 * DO NOT USE THIS!
 * @deprecated Please use the new IntegerValidatorFactoryService from shell-models-lib
 */
export class IntegerValidatorFactoryService implements IValidatorFactoryService<IIntegerMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'integer';

    public createValidatorByMetadata(metadata: IIntegerMetadata): IValidatorFn {
        return this.createValidator(metadata.min, metadata.max, metadata.errorMessage);
    }
    public createValidator(min: number = -Number.MAX_VALUE, max: number = Number.MAX_VALUE, errMsg?: string): IValidatorFn {
        const errorMessage = errMsg != null ? errMsg : stringResources.Validator_ErrorMessage_Integer;
        return (value: number) => {
            return (_.isInteger(+value) && (value >= min) && (value <= max)) ? null : errorMessage;
        };
    }
}
